// React
import React from 'react';

// Tanstack Query
import { QueryClient } from '@tanstack/react-query';

//pages
import { ClaimManagement } from 'pages/claims';
import { useAdminClaimManagementData } from './useAdminClaimManagementData';

interface AdminClaimManagementProps {
  queryClient: QueryClient;
}

export const AdminClaimManagement: React.FC<AdminClaimManagementProps> = ({
  queryClient,
}) => {
  const {
    claims,
    claimStatuses,
    providers,
    sites,
    status,
    payors,
    remittances,
    eobs,
    eobCounts,
    isLoading,
    isError,
    isFetching,
    pagination,
    setPagination,
    errorMessage,
    refetchClaims,
    refetchStatusesCount,
    loadEobLookups,
  } = useAdminClaimManagementData(queryClient);
  return (
    <ClaimManagement
      claims={claims}
      claimStatuses={claimStatuses}
      providers={providers}
      sites={sites}
      status={status}
      payors={payors}
      remittances={remittances}
      eobs={eobs}
      eobCounts={eobCounts}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      setPagination={setPagination}
      pagination={pagination}
      invalidData={claims.invalidData}
      errorMessage={errorMessage}
      refetchClaims={refetchClaims}
      refetchStatusesCount={refetchStatusesCount}
      loadEobLookups={loadEobLookups}
    />
  );
};
